import type { Department } from '@api/DepartmentService';
import { useOrgDepartmentsEntry } from '@stores/departmentStore';

interface UseDepartmentsResult {
    departments: Department[] | undefined;
    isLoadingDepartments: boolean;
    fetchDepartments: () => void;
}

const useDepartments = (orgId: string): UseDepartmentsResult => {
    const {
        response: departments,
        isLoading: isLoadingDepartments,
        requestApiCall: fetchDepartments,
    } = useOrgDepartmentsEntry(orgId);

    return {
        departments,
        isLoadingDepartments,
        fetchDepartments,
    };
};

export default useDepartments;
